<div style="padding: 2rem;">

  <!-- Page header -->
  <div style="margin-bottom: 2rem;">
    <h1 style="font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem;">
      Tableau de bord
    </h1>
    <p style="font-size: 0.875rem; color: #64748b; margin: 0;">
      Vue d'ensemble de l'activité Afrilink
    </p>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center py-16">
    <app-loading [isVisible]="loading"></app-loading>
  </div>

  <!-- Stats grid -->
  <div *ngIf="!loading"
       class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
       style="gap: 1.25rem;">

    <a *ngFor="let d of data; let i = index"
       [routerLink]="d.link"
       class="block no-underline group"
       style="border-radius: 14px; overflow: hidden; transition: transform 0.2s, box-shadow 0.2s; text-decoration: none;">

      <div class="group-hover:-translate-y-1"
           style="padding: 1.5rem; border-radius: 14px; transition: all 0.2s;"
           [style.background]="i % 4 === 0 ? 'linear-gradient(135deg, #2E3190, #3a3eaa)' :
                               i % 4 === 1 ? 'linear-gradient(135deg, #FAB818, #f7cc5a)' :
                               i % 4 === 2 ? 'linear-gradient(135deg, #0f172a, #1e293b)' :
                               'linear-gradient(135deg, #0d9488, #14b8a6)'"
           [style.color]="i % 4 === 1 ? '#1e293b' : 'white'"
           [style.box-shadow]="i % 4 === 0 ? '0 4px 20px rgba(46,49,144,0.25)' :
                               i % 4 === 1 ? '0 4px 20px rgba(250,184,24,0.3)' :
                               i % 4 === 2 ? '0 4px 20px rgba(15,23,42,0.25)' :
                               '0 4px 20px rgba(13,148,136,0.25)'">

        <!-- Top row -->
        <div class="flex items-start justify-between" style="margin-bottom: 1.25rem;">
          <div style="width: 44px; height: 44px; border-radius: 12px; background: rgba(255,255,255,0.18); display: flex; align-items: center; justify-content: center;">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
            </svg>
          </div>
          <svg class="w-5 h-5 group-hover:translate-x-1 transition-transform"
               style="opacity: 0.6;"
               fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
          </svg>
        </div>

        <!-- Value -->
        <p style="font-size: 2rem; font-weight: 800; margin: 0 0 0.25rem; line-height: 1;">
          {{ d.value }}
        </p>
        <p style="font-size: 0.8125rem; font-weight: 500; margin: 0; opacity: 0.78;">
          {{ d.name }}
        </p>
      </div>
    </a>
  </div>

  <!-- Empty state -->
  <div *ngIf="!loading && data.length === 0"
       class="flex flex-col items-center justify-center py-24 text-center">
    <div style="width: 72px; height: 72px; border-radius: 50%; background: #f1f5f9; display: flex; align-items: center; justify-content: center; margin-bottom: 1rem;">
      <svg class="w-8 h-8" style="color: #94a3b8;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
      </svg>
    </div>
    <p style="color: #64748b; font-weight: 500; margin: 0;">Aucune donnée disponible</p>
  </div>

</div>
